import { render } from "./ExportationFiles.vue?vue&type=template&id=460f3aca"
import script from "./ExportationFiles.vue?vue&type=script&lang=js"
export * from "./ExportationFiles.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/components/views/customer/query/basic_containers/show_container/exportation_files.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fcustomer%2Fquery%2Fbasic_containers%2Fshow_container%2FExportationFiles.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/models/exportation_attachment.yml?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fcustomer%2Fquery%2Fbasic_containers%2Fshow_container%2FExportationFiles.vue&lang=yaml"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__